import React, { Fragment } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import language from '../../../config/es';

// Campo de fecha del filtro
const DateField = ({ title, onChange }) => (
  <Col sm={3} lg={3} xl={2}>
    <h6 className="title">{title}</h6>
    <FormGroup>
      <Datetime
        className="text-uppercase small"
        timeFormat={false}
        initialValue={new Date()}
        onChange={onChange}
        inputProps={{
          readOnly: true,
          className: 'form-control small',
        }}
        dateFormat="DD/MM/YYYY"
      />
    </FormGroup>
  </Col>
);

// Filtro de rango de fechas (fecha inicio y fecha fin)
const DateRangeFilter = ({ onChangeDate, onChangeDateEnd }) => (
  <Fragment>
    <DateField
      title={language.messages.monitor.lblDateIni}
      onChange={onChangeDate}
    />
    <DateField
      title={language.messages.monitor.lblDateEnd}
      onChange={onChangeDateEnd}
    />
  </Fragment>
);

export default DateRangeFilter;
